import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/publish.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2e9e72fe"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "download"
};
var _hoisted_2 = {
  key: 0,
  class: "tip"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-zhushi"
  }, null, -1);
});
var _hoisted_4 = ["href"];
var _hoisted_5 = {
  class: "download-title"
};
var _hoisted_6 = {
  key: 1,
  class: "download-main"
};
var _hoisted_7 = {
  class: "flex"
};
var _hoisted_8 = {
  class: "download-info"
};
var _hoisted_9 = {
  class: "download-info-name"
};
var _hoisted_10 = {
  class: "download-info-other"
};
var _hoisted_11 = {
  class: "download-info-other"
};
var _hoisted_12 = {
  class: "download-right"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  key: 2,
  class: "no-more"
};
var _hoisted_16 = {
  class: "dialog"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-shijian"
  }, null, -1);
});
var _hoisted_18 = ["innerHTML"];
var __default__ = {
  name: 'AppDownLoad'
};
import Ellipsis from '@/components/ellipsis/index.vue';
import downloadFile from '@/utils/download';
import { useMatomo } from '@shining3d/matomo';
import { XlDialog } from '@shining3d/ui-components';
import { useStore } from 'vuex';
import { $convertUTCDateToLocalDate, $getCdnUrl } from '../../../assets/common/common';
import { useLang } from '../../../hooks/lang';
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    query: {
      type: String,
      default: ''
    },
    // 自定义name
    name: {
      type: String,
      default: ''
    },
    software: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var _useLang = useLang(),
      $t = _useLang.$t;
    var matomo = useMatomo();
    var download = function download(item) {
      var url = $getCdnUrl({
        bucket: item.bucket,
        dfsID: item.dfsID
      }, false);
      url && downloadFile(url);
      matomo.log('click', '支持与下载|软件下载|下载', '下载产品软件');
    };
    var dialogVisible = ref(false);
    var versionLog = ref('');
    var createTime = ref('');
    var openDialog = function openDialog(item) {
      dialogVisible.value = true;
      versionLog.value = item.versionLog;
      createTime.value = $convertUTCDateToLocalDate(item.createOn, 'YYYY-MM-DD');
    };
    var store = useStore();
    onMounted(function () {
      store.commit('setComponentNum', 1);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.software ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, [_hoisted_3, _createTextVNode(_toDisplayString(_unref($t)("solidEdgeTip")) + " ", 1), _createElementVNode("a", {
        href: "mailto:".concat(_unref($t)('solidEdgeEmail'))
      }, _toDisplayString(_unref($t)("solidEdgeEmail")), 9, _hoisted_4)])])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_5, _toDisplayString(__props.name || _unref($t)("appDownLoad")), 1), __props.list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "download-main-item",
          key: index
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("i", {
          class: _normalizeClass(["iconfont main-icon", item.os === 'mac' ? 'icon-pingguo' : 'icon-a-bianzu10'])
        }, null, 2), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, [_createVNode(Ellipsis, {
          text: item.name,
          "font-size": 16,
          width: 360,
          query: __props.query
        }, null, 8, ["text", "query"])]), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref($t)("appVersion")) + _toDisplayString(item.version), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_unref($t)("OS")) + _toDisplayString(item.os), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, [_createElementVNode("img", {
          src: _imports_0,
          onClick: function onClick($event) {
            return openDialog(item);
          },
          alt: ""
        }, null, 8, _hoisted_13), _createElementVNode("i", {
          class: "iconfont icon-xiazai-xian",
          onClick: function onClick($event) {
            return download(item);
          }
        }, null, 8, _hoisted_14)])])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(_unref($t)("common.noData")), 1)])), _createVNode(_unref(XlDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return dialogVisible.value = $event;
        }),
        width: "340px",
        title: _unref($t)('releaseRecord')
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createTextVNode(" " + _toDisplayString(createTime.value), 1)]), _createElementVNode("div", {
            class: "dialog-main",
            innerHTML: versionLog.value
          }, null, 8, _hoisted_18)];
        }),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
});